import { faClock, faRotate } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { ThreeDots } from "react-loader-spinner";

import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import {
  HEADER_CHIP_BACKGROUND,
  HEADER_CHIP_FONT_SIZE,
  HEADER_CHIP_HEIGHT,
  HEADER_CHIP_ICON_SIZE,
  HEADER_CHIP_LOADER_WIDTH,
  HEADER_CHIP_PADDING_X,
  HEADER_CHIP_RADIUS,
  HEADER_COMPACT_CHIP_FONT_SIZE,
  HEADER_COMPACT_CHIP_HEIGHT,
  HEADER_COMPACT_CHIP_PADDING_X,
  HEADER_DIVIDER_HEIGHT,
  HEADER_DIVIDER_WIDTH,
  HEADER_ITEM_HOVER_BACKGROUND,
  HEADER_SESSION_COLLAPSED_WIDTH,
  HEADER_SESSION_CONTENT_TRANSITION,
  HEADER_SESSION_EXPANDED_WIDTH,
  HEADER_SESSION_EXPAND_TRANSITION,
  HEADER_SESSION_GAP
} from "./header-constants";
import { getHeaderIsCompactFromStore } from "./header-layout";

type THeaderSessionChip = {
  activeLabel: string;
  refreshLabel: string;
  isLoading: boolean;
};

const HeaderSessionChip = withLiteObserverAndTheme<THeaderSessionChip>(
  (props) => {
    const { activeLabel, refreshLabel, isLoading, theme } = props;
    const { colors, unitX, unitY } = theme;
    const isCompact = getHeaderIsCompactFromStore();
    const [hasUserToggled, setHasUserToggled] = useState(false);
    const [userWantsOpen, setUserWantsOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const isOpen = hasUserToggled ? userWantsOpen : !isCompact;
    const chipHeight = isCompact
      ? HEADER_COMPACT_CHIP_HEIGHT
      : HEADER_CHIP_HEIGHT;
    const chipPaddingX = isCompact
      ? HEADER_COMPACT_CHIP_PADDING_X
      : HEADER_CHIP_PADDING_X;
    const fontSize = isCompact
      ? HEADER_COMPACT_CHIP_FONT_SIZE
      : HEADER_CHIP_FONT_SIZE;

    return (
      <button
        aria-expanded={isOpen}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => {
          setHasUserToggled(true);
          setUserWantsOpen(!isOpen);
        }}
        style={{
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          flexShrink: 0,
          border: 0,
          cursor: "pointer",
          backgroundColor: isHovered
            ? HEADER_ITEM_HOVER_BACKGROUND
            : HEADER_CHIP_BACKGROUND,
          height: chipHeight * unitY,
          width: "auto",
          maxWidth:
            (isOpen
              ? HEADER_SESSION_EXPANDED_WIDTH
              : HEADER_SESSION_COLLAPSED_WIDTH) * unitX,
          justifyContent: "flex-start",
          borderRadius: HEADER_CHIP_RADIUS * unitX,
          paddingLeft: chipPaddingX * unitX,
          paddingRight: chipPaddingX * unitX,
          gap: HEADER_SESSION_GAP * unitX,
          whiteSpace: "nowrap",
          overflow: "hidden",
          transition: HEADER_SESSION_EXPAND_TRANSITION
        }}
      >
        <FontAwesomeIcon
          icon={faClock}
          color={colors.all.brightCyan}
          style={{
            width: HEADER_CHIP_ICON_SIZE * unitX,
            height: HEADER_CHIP_ICON_SIZE * unitY,
            flexShrink: 0
          }}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: HEADER_SESSION_GAP * unitX,
            flexShrink: 0,
            whiteSpace: "nowrap",
            opacity: isOpen ? 1 : 0,
            pointerEvents: "none",
            transition: HEADER_SESSION_CONTENT_TRANSITION
          }}
        >
          {isLoading ? (
            <ThreeDots
              color={colors.all.brightCyan}
              height={HEADER_CHIP_ICON_SIZE}
              width={HEADER_CHIP_LOADER_WIDTH}
            />
          ) : (
            <Et3Text
              fontFamily={"MEDIUM"}
              fontSize={fontSize}
              text={activeLabel}
              isSpan={false}
              color={colors.all.maastrichtBlue}
              style={{ margin: 0, whiteSpace: "nowrap" }}
            />
          )}
          <div
            style={{
              width: HEADER_DIVIDER_WIDTH * unitX,
              height: HEADER_DIVIDER_HEIGHT * unitY,
              flexShrink: 0,
              backgroundColor: colors.all.shadeOfGray
            }}
          />
          <FontAwesomeIcon
            icon={faRotate}
            color={colors.all.darkOrange}
            style={{
              width: HEADER_CHIP_ICON_SIZE * unitX,
              height: HEADER_CHIP_ICON_SIZE * unitY,
              flexShrink: 0
            }}
          />
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={fontSize}
            text={refreshLabel}
            isSpan={false}
            color={colors.all.maastrichtBlue}
            style={{ margin: 0, whiteSpace: "nowrap" }}
          />
        </div>
      </button>
    );
  }
);
export default HeaderSessionChip;
